import App from 'app/App';
import React from 'react';
import ReactDOM from 'react-dom/client';

const rootDOM = document.getElementById('root');
if (rootDOM) {
  const root = ReactDOM.createRoot(rootDOM);
  root.render(<App />);
}
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(() => {
      console.log('Service worker active')
    })
    .catch(() => {
      console.log('Service worker fail')
    });
  });
}
